/**
 * Copyright (c) 2019, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Localized from '../../../../shared/components/Localized';
import Button from '../../../components/Button';
import { StandardIcon } from '../../../components/SVGIcon';
import styles from '../../../styles';

const Wrapper = styled.div`
  padding: 1rem;
  background-color: ${styles.colors.linkWater};
  border-radius: 0.25rem;
  display: flex;
  @media (max-width: 767px) {
    padding: 1.25rem;
  }
  @media (max-width: 610px) {
    flex-wrap: wrap;
  }
`;

const Icon = styled.div`
  padding-right: 1rem;
`;

const Heading = styled.div`
  ${styles.fonts.headingMedium}
  margin-top: -0.25rem;
`;

const ButtonWrapper = styled.div`
  ${Button} + ${Button} {
    margin-left: 0.75rem;
  }
`;

const LeftWrapper = styled.div`
  margin-left: auto;
  margin-right: 0.75rem;
`;

const SubTitle = styled.div`
  font-size: 0.75rem;
  line-height: 1.25;
  color: #54698d;
`;

const BoldText = styled.span`
  font-weight: bold;
`;

const SubscribeButtonLarge = styled(Button)`
  margin-top: 0.75rem;
  @media (min-width: 320px) and (max-width: 1022px) {
    display: none;
  }
`;

const SubscribeButtonSmall = styled(Button)`
  @media (min-width: 1023px) {
    display: none;
  }
`;

/**
 * Header for the General Messages.
 * This component accepts only one prop - a count for number of general messages
 */
const Header = ({ messageCount, onSubscribeClick }) => (
  <Wrapper>
    <Icon>
      <StandardIcon icon="announcement" bgColor="#2f749c" size="2.5rem" round />
    </Icon>
    <div>
      <Heading>
        <Localized
          modelKey="informational"
          modelAttribute="label"
          modelName="statusKey"
        />
      </Heading>
      <SubTitle>
        <Localized
          modelKey="past90days"
          modelAttribute="label"
          modelName="generalMessage"
        />
        {' • '}
        <BoldText>
          {' '}
          {messageCount}{' '}
          <Localized
            modelKey="items"
            modelAttribute="label"
            modelName="subscriptions"
          />
        </BoldText>
      </SubTitle>
    </div>
    <LeftWrapper>
      <ButtonWrapper>
        <Link to={'/subscriptions'}>
          <SubscribeButtonLarge theme="brand">
            <Localized
              modelKey="headerModal"
              modelName="signupModal"
              modelAttribute="value"
            />
          </SubscribeButtonLarge>
        </Link>
        <Link to={'/subscriptions'}>
          <SubscribeButtonSmall theme="brand">
            <Localized
              modelKey="subscribe"
              modelName="button"
              modelAttribute="label"
            />
          </SubscribeButtonSmall>
        </Link>
      </ButtonWrapper>
    </LeftWrapper>
  </Wrapper>
);

Header.propTypes = {
  messageCount: PropTypes.number
};

export default Header;
